(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations').controller('onvio.setup.migrations.NewMigrationMainController', newMigrationCtrl);

    newMigrationCtrl.$inject = ['$scope', '$rootScope', '$q', '$translate', '$stateParams', '$uibModal', '$compile', '$document',
                                '$location', '$timeout', 'bmpConfirmationDialog',
                                'resolve.translationsLoaded', 'migrationApps', 'migrationConfig', 'migrationService'];

    function newMigrationCtrl($scope, $rootScope, $q, $translate, $stateParams, $uibModal, $compile, $document, $location, $timeout,
                              bmpConfirmationDialog, translationsLoaded, migrationApps, migrationConfig, migrationService) {
        /*jshint validthis:true */
        var vm = this;
        $scope.migrationConfig = migrationConfig;   // in order to passs to children's controller
        $scope.appToMigrate = '';
        $scope.pathToData = '';
        $scope.appsMigrateOptions = [];
        for (var i = 0; i < migrationConfig.installedProducts.length; i++) {
            var item = migrationConfig.installedProducts[i];
            var opt = {
                value: item.product,
                name: 'Onvio.Migrations.Product.' + migrationService.normalizeName(item.product)
            };
            $scope.appsMigrateOptions.push(opt);
        }

        $scope.dataPathOptions = [];
        $scope.currentProduct = null;
        $scope.$watch('appToMigrate', function(newValue) {
            $scope.currentProduct = null;
            for (var i = 0; i < migrationConfig.installedProducts.length; i++) {
                var item = migrationConfig.installedProducts[i];
                if (item.product === newValue) {
                    $scope.currentProduct = item;
                    break;
                }
            }
            vm.updateDataPathOptions();
        });

        vm.updateDataPathOptions = function() {
            $scope.dataPathOptions.splice(0, $scope.dataPathOptions.length);
            if ( angular.isUndefined($scope.currentProduct) || $scope.currentProduct === null) {
                return;
            }
            var productMeta = $scope.currentProduct.productMeta;
            if ( angular.isUndefined(productMeta) ) {
                return;
            }
            // preserve \ in the paths
            var metaJson = JSON.parse(productMeta.replace(/\\/g, '\\\\'));
            if ( angular.isUndefined(metaJson.dataPaths) ) {
                return;
            }
            var paths = metaJson.dataPaths;
            for (var i = 0; i < paths.length; i++) {
                $scope.dataPathOptions.push(paths[i]);
            }
        };

        $scope.availableDrawerList = [];
        $scope.selectedDrawerList = [];
        $scope.hideNextButton = false;
        $scope.hidePreviousButton = false;
        $scope.migrationDescription = '';

        $scope.screens = {
            appsNetwork:  0,
            desktopUtility: 1,
            drawerSelection: 2,
            confirmation: 3
        };
        $scope.stepDisabled = [false, true, true, true];
        $scope.step = 0;                // -1 from the step display
        $scope.totalStep = 4;

        $scope.busyLoading = false;
        $scope.loadingFailed = false;

        $scope.clickBrowseFolder = function() {
            $scope.pathToData = '132213';
            /*
            var result = document.getElementsById("folderSelector");
            var wrappedResult = angular.element(result);
            wrappedResult.triggerHandler("click");
            //$( "input" ).triggerHandler( "focus" );
            */
            /*
            var hiddenInput = $document[0].querySelector('#folderSelector');
            // var result = $document[0].getElementsById("folderSelector");
            //var hiddenInput = angular.element(result);

            //var inputId = 'xdd-input';
            //$document[0].append($compile('<input type=\"file\" id=\"' + inputId + '\" style=\"display: none\" ng-file-select=\"onFileSelect($files)\" multiple />')(scope));
            //var hiddenInput = $document[0].querySelector('#' + inputId);
            hiddenInput.value = null;

            if ($document[0].createEvent) {
                var evt = $document[0].createEvent('MouseEvents');
                evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                hidddenInput.dispatchEvent(evt);
            } else {
                hidddenInput.click();
            }
            */
        };

        $scope.selectFolder = function(event) {
            /*
            var theFiles = e.target.files;
            var relativePath = theFiles[0].webkitRelativePath;
            var folder = relativePath.split("/");
            $scope.pathToData = folder[0];
            */
           /*
            $scope.$apply(function(scope) {
                var photofile = element.files[0];
                var reader = new FileReader();
                reader.onload = function(e) {
                // handle onload
                };
                reader.readAsDataURL(photofile);
            }); */
            var fileList = event.files;
            var relativePath = fileList[0].webkitRelativePath;
            var folder = relativePath.split('/');
            $scope.pathToData = folder[0];
            //$scope.pathToData = "132213"; not set????
        };

        $scope.cancelNewMigration = function() {
            if( !vm.isAppsNetworkFormAnyDirty() ) {
                $location.url(migrationApps.migrationHomeUrl);
                return;
            }
            bmpConfirmationDialog.open({
                titleText: $scope.omtrans('New.CancelTitle'),
                bodyText: $scope.omtrans('New.CancelBody'),
                confirmText: $translate.instant('Onvio.Setup.Common.Buttons.Yes'),
                cancelText: $translate.instant('Onvio.Setup.Common.Buttons.No')
            }).then(function() {
                $location.url(migrationApps.migrationHomeUrl);
            });
        };

        $scope.showStartMigrationButton = function() {
            if($scope.step !== $scope.screens.drawerSelection) {
                return false;
            }
            if($scope.selectedDrawerList.length > 0) {
                return true;
            }
            return false;
        };

        $scope.showCancelButton = function() {
            return ($scope.step !== $scope.screens.confirmation)? true : false;
        };

        $scope.onWizardChange = function(step) {
            // -1 from the step display
            $scope.hideNextButton = false;
            $scope.desktopUtilityChecking = false;
            if(step !== $scope.screens.appsNetwork) {
                var valid1 = vm.isDescriptionFormValid();
                var valid2 = vm.isAppsNetworkFormValid();
                if( !valid1 || !valid2 ) {
                    $scope.step = $scope.screens.appsNetwork;
                    return false;
                }
            }
            if(step === $scope.screens.drawerSelection) {
                $scope.hideNextButton = true;
                $rootScope.$broadcast('load-drawers');
            }
            if(step === $scope.screens.desktopUtility) {
                vm.checkDesktopUtility();
                $scope.stepDisabled[$scope.screens.drawerSelection] = false;
            }
        };

        $scope.desktopUtilityChecking = false;
        $scope.connectionFailed = false;
        $scope.connectionAlerts = [];
        vm.checkStartTime = Date.now();
        vm.checkDesktopUtility = function() {
            $scope.desktopUtilityChecking = true;
            $scope.connectionFailed = false;
            $scope.connectionAlerts .splice(0, $scope.connectionAlerts.length);
            vm.checkStartTime = Date.now();
            vm.checkDesktopUtilityImpl();
        };

        vm.checkDesktopUtilityImpl = function() {
            var dt = Date.now() - vm.checkStartTime;
            if (dt > 10000) {
                $scope.desktopUtilityChecking = false;
                $scope.connectionFailed = true;
                $scope.connectionAlerts.push({
                    type: 'danger',
                    msg: $translate.instant('Onvio.Migrations.DesktopUtility.NoConnection'),
                    closeable: true
                });
                return;
            }
            $timeout(vm.checkDesktopUtilityImpl, 500);
        };

        $scope.onWizardFinish = function() {
            $location.url(migrationApps.migrationHomeUrl);
        };

        $scope.startMigration = function() {
            var migrationInfo = {
                description: $scope.migrationDescription
            };
            if ($scope.appToMigrate ===  migrationApps.fileCabinet) {
                var detail = vm.createFileCabinetMigrationInfo();
                migrationInfo = angular.extend(migrationInfo, detail);
            }
            $scope.busyLoading = true;
            migrationService.createNewMigration(migrationConfig.companyId, migrationConfig.contactId,
                                                $scope.currentProduct.migrationProductId, migrationInfo)
            .then( function() {
                $scope.stepDisabled[$scope.screens.confirmation] = false;
                $scope.stepDisabled[$scope.screens.appsNetwork] = true;
                $scope.stepDisabled[$scope.screens.desktopUtility] = true;
                $scope.stepDisabled[$scope.screens.drawerSelection] = true;
                $scope.step = $scope.screens.confirmation;
                $scope.hidePreviousButton = true;
            }, function() {
                $scope.step = $scope.screens.drawerSelection;
            })
            .finally(function() {
                $scope.busyLoading = false;
            });
        };

        vm.createFileCabinetMigrationInfo = function() {
            var migrationMeta = {
                dataPath: $scope.pathToData
            };
            var items = [];
            for (var i = 0; i < $scope.selectedDrawerList.length; i++) {
                var drawer = $scope.selectedDrawerList[i];
                var dto = {
                    migrationSetId: drawer.migrationSetId
                };
                items.push(dto);
            }
            return {
                migrationMeta: JSON.stringify(migrationMeta),
                items: items
            };
        };

        vm.isDescriptionFormValid = function() {
            if ( !$scope.migrationDescription || ($scope.migrationDescription.trim().length === 0)) {
                $scope.descriptionForm.migrationDescription.$dirty = true;
                return false;
            }
            return true;
        };

        vm.isAppsNetworkFormValid = function() {
            var isValid = true;
            if ( !$scope.appToMigrate || ($scope.appToMigrate.trim().length === 0)) {
                $scope.appsNetworkForm.appToMigrate.$dirty = true;
                isValid = false;
            }
            if ( !$scope.pathToData || ($scope.pathToData.trim().length === 0)) {
                $scope.appsNetworkForm.pathToData.$dirty = true;
                isValid = false;
            }
            return isValid;
        };

        vm.isAppsNetworkFormAllDirty = function() {
             var dirty = ($scope.descriptionForm.migrationDescription.$dirty &&
                          $scope.appsNetworkForm.appToMigrate.$dirty && $scope.appsNetworkForm.pathToData.$dirty);
             return dirty;
        };

        vm.isAppsNetworkFormAnyDirty = function() {
             var dirty = ($scope.descriptionForm.migrationDescription.$dirty ||
                          $scope.appsNetworkForm.appToMigrate.$dirty || $scope.appsNetworkForm.pathToData.$dirty);
             return dirty;
        };

        $scope.disableDesktopUtility = function() {
            if($scope.step === $scope.screens.confirmation) {
                return true;
            }
            var dirty = vm.isAppsNetworkFormAllDirty();
            $scope.stepDisabled[$scope.screens.desktopUtility] = !dirty;
            return !dirty;
        };

        $scope.omtrans = function(text) {
            return $translate.instant('Onvio.Migrations.' + text);
        };

        $scope.selectFileCabinet = function() {
            if($scope.appToMigrate === migrationApps.fileCabinet) {
                return true;
            }
            return false;
        };

    }

})(window.angular);
